export const Setting = {
  ClientVersionMin: 'Minimální verze klienta',
  MaintenanceInProgress: 'Udržba systému',
  SettingUpdated: 'Nastavení aktualizováno',
  Title: 'Nastavení',
};
